var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTxtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7998 5.59595C2.7998 5.37755 2.9818 5.19995 3.2014 5.19995H20.7982C21.0202 5.19995 21.1998 5.38035 21.1998 5.59595V7.20395C21.1998 7.42235 21.0178 7.59995 20.7982 7.59995H3.2014C2.9816 7.60041 2.80244 7.42374 2.7998 7.20395V5.59595ZM2.7998 11.196C2.7998 10.9776 2.9818 10.8 3.2014 10.8H20.7982C21.0202 10.8 21.1998 10.9804 21.1998 11.196V12.804C21.1998 13.0224 21.0178 13.2 20.7982 13.2H3.2014C2.9816 13.2004 2.80244 13.0237 2.7998 12.804V11.196ZM3.199 16.4C2.9786 16.4 2.7998 16.5776 2.7998 16.796V18.404C2.80199 18.623 2.97996 18.7995 3.199 18.8H14.4006C14.621 18.8 14.7998 18.6224 14.7998 18.404V16.796C14.7976 16.5769 14.6197 16.4004 14.4006 16.4H3.199Z",
    fill: "#637282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxtIcon);
export default __webpack_public_path__ + "static/media/txt-icon.fd5a83cf.svg";
export { ForwardRef as ReactComponent };